class MegaMenuHandler {
    constructor() {
        // Sélectionnez tous les éléments .wp-block-navigation-item.mega-menu
        this.megaMenuItems = document.querySelectorAll('.wp-block-navigation-item.mega-menu');

        // Attachez un gestionnaire d'événements à chaque bouton dans .wp-block-navigation-item__content
        this.megaMenuItems.forEach((menuItem) => {
            menuItem.querySelector('.wp-block-navigation-item__content').addEventListener('click', (event) => this.handleButtonClick(event, menuItem));
        });

        // Écoutez les clics sur l'ensemble du document pour fermer le sous-menu si nécessaire
        document.addEventListener('click', (event) => this.handleClickOutsideMenu(event));
    }

    handleButtonClick(event, menuItem) {
        event.preventDefault();

        // Vérifiez si le menu est actuellement ouvert
        const isOpen = menuItem.classList.contains('submenu-open');

        // Fermez tous les .mega-submenu-wrapper sauf celui du clic actuel
        this.closeAllMegaSubmenus();

        if (!isOpen) {
            // Ouvrez le .mega-submenu-wrapper avec la classe submenu-open
            menuItem.classList.add('submenu-open');
        }
    }

    closeAllMegaSubmenus() {
        this.megaMenuItems.forEach((submenu) => {
            submenu.classList.remove('submenu-open');
        });
    }

    handleClickOutsideMenu(event) {
        // Vérifiez si le clic est en dehors des éléments .wp-block-navigation-item.mega-menu
        if (!event.target.closest('.wp-block-navigation-item.mega-menu')) {
            // Fermez tous les sous-menus
            this.closeAllMegaSubmenus();
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Instanciez la classe lorsque le DOM est chargé
    new MegaMenuHandler();
});
